const fundPercent = {
  NGN: 0.014,
  HABARI: 0.005,
  USD: 0.038,
  THEPEER: 0.005,
  FLUIDCOINS: 0.01,
  APPLEPAY: 1,
};
export default fundPercent;
